/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { workloadIdentitiesGetCustomFlows } from "../funcs/workloadIdentitiesGetCustomFlows.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { WorkloadCustomFlows } from "../models/components/workloadcustomflows.js";
import {
  GetWorkloadCustomFlowsRequest,
  GetWorkloadCustomFlowsSecurity,
} from "../models/operations/getworkloadcustomflows.js";
import { unwrapAsync } from "../types/fp.js";
export type WorkloadCustomFlowsQueryData = WorkloadCustomFlows;

export function prefetchWorkloadCustomFlows(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetWorkloadCustomFlowsRequest | undefined,
  security?: GetWorkloadCustomFlowsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWorkloadCustomFlowsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWorkloadCustomFlowsQuery(
  client$: GramCore,
  request?: GetWorkloadCustomFlowsRequest | undefined,
  security?: GetWorkloadCustomFlowsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<WorkloadCustomFlowsQueryData>;
} {
  return {
    queryKey: queryKeyWorkloadCustomFlows({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function workloadCustomFlowsQueryFn(
      ctx,
    ): Promise<WorkloadCustomFlowsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(workloadIdentitiesGetCustomFlows(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWorkloadCustomFlows(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "workloadIdentities", "getCustomFlows", parameters];
}
